import { createContext, useReducer } from "react";
import { localStorageData } from "../../common/constants/Settings";

/** Constante del contexto de Autorizacion */
export const AuthContext = createContext({});

/** Reducer que se encarga de las acciones de autorizacion */
const authReducer = (state = {}, action) => {
	switch (action.type) {
		case "LOGIN":
			return {
				...state,
				isAuthenticated: true,
				user: action.payload.user,
			};
		case "LOGOUT":
			return {
				...state,
				isAuthenticated: false,
				user: null,
			};
		case "REFRESH":
			return {
				...state,
				isAuthenticated: action.payload.isAuthenticated,
				user: action.payload.user,
			};
		default:
			return state;
	}
};

/** Funcion que inicializa el estado del contexto de autorizacion */
const init = () => {
	const user = JSON.parse(localStorage.getItem(localStorageData.USER));

	return {
		isAuthenticated: !!user,
		user: user,
	}
};

/** Provider de autorizacion */
export const AuthProvider = (props) => {
	const [state, dispatch] = useReducer(authReducer, {}, init);

	const login = (response) => {
		const action = {
			type: "LOGIN", 
			payload: {
				user: response
			} 
		};

		localStorage.setItem(localStorageData.USER, JSON.stringify(response));

		dispatch(action);
	};

	const logout = () => {
		localStorage.removeItem(localStorageData.USER);
		const action = {
			type: "LOGOUT"
		};

		dispatch(action);
	};

	const refresh = (response) => {
		const action = {
			type: "REFRESH",
			payload: {
				user: response.user,
				isAuthenticated: response.auth
			} 
		};

		localStorage.setItem(localStorageData.USER, JSON.stringify(response.user));

		dispatch(action);
	};

	return (
		<AuthContext.Provider
			value={{
				...state,
				dispatch,
				login,
				logout,
				refresh
			}}
		>
			{props.children}
		</AuthContext.Provider>
	);
};
